export const version = {
  date: '2026-08-20T18:19:48.965Z',
  branch: 'HEAD',
  revision: 'f25690a',
};